const trans = {
  Integrations: "اعدادات الدمج",
  Payments: "الدفع",
  "Add a payment gateway": "فعل بوابة دفع",
  "Frontlines settings": "اعدادات Frontlines",
  "OGO settings": "اعدادات OGO",
  "Mirsal settings": "اعدادات مرسال",
  "Bookeey settings": "اعدادات بوكي",
  "UPay settings": "اعدادات UPay",
  "MyFatoorah settings": "اعدادات MyFatoorah",
  "Tap settings": "اعدادات Tap",
  "Hesabe settings": "اعدادات حسابي",
  "Print QR Code": "اطبع كود QR",
  Messaging: "المراسلة",
  "SMS settings": "اعدادات الرسئل النصية",
  "Enable SMS": "تفعيل الرسائل النصية",
  "Whatsapp settings": "اعدادات واتساب",
  "Enable Whatsapp": "تفعيل الواتساب",
  Balance: "الرصيد",
  "Sender ID": "اسم المرسل",
  points: "نقطة",
  "For delivery": "للتوصيل",
  "For pickup": "للاستلام",
  "Import Cin7 products": "رفع منتجات سين 7",
  "Products are being imported": "يتم حاليا تحميل المنتجات",
  "Could not import products": "لم نتمكن من تحميل المنتجات",
  "Countries with offline payments (Cash/KNET on delivery)":
    "الدول التي تدعم الكاش والكي نت عند الاستلام",
  "Pay with card on delivery": "الدفع بالبطاقة عند الاستلام",
  "Offline payments": "الدفع الغير الكتروني",
  "Online payments": "الدفع الالكتروني",
  "Enabled for the following countries": "مفعل للدول التالية",
  "Enable Debit/Credit Card Transactions": "تفعيل معاملات دفع الاونلاين",
  "Cin7 Branch ID": "سين7 رمز الفرع",
  "Test mode": "الوضع التجريبي",
  "Enable this only when you're provided with test credentials from Benefit. Make sure to turn it off once you're done testing":
    "قم بالتفعيل عند تزويدك بمفاتيح بنفت التجريبية. عند الانتهاء من التجريب، قم بتعطيل الزر حتى يتمكن عملائك من استخدام البوابة",
  "Enable this only when you're provided with test credentials from Credimax. Make sure to turn it off once you're done testing":
    "قم بالتفعيل عند تزويدك بمفاتيح كريدي ماكس التجريبية. عند الانتهاء من التجريب، قم بتعطيل الزر حتى يتمكن عملائك من استخدام البوابة",
  "Enable this only when you're provided with test credentials from TPay. Make sure to turn it off once you're done testing":
    "قم بالتفعيل عند تزويدك بمفاتيح تي باي التجريبية. عند الانتهاء من التجريب، قم بتعطيل الزر حتى يتمكن عملائك من استخدام البوابة",
  "Currency Conversion": "تحويل العملات",
  "Enable currency conversion": "تفعيل تحويل العملات",
  "Enable rounding": "تفعيل التقريب",
  "Rounding rule": "تقريب الى",
  "Currency rates (updated daily)": "أسعار العملات (محدث يوميا)",
  "Last updated:": "آخر تحديث:",
  recommended: "مقترح",
  "Delivery Providers": "شركات التوصيل",
  "Manage delivery providers": "التحكم بإعدادات شركات التوصيل",
  "Add a delivery provider": "اضافة شركة توصيل",
  "Connect your store to your social channels like Instagram and Facebook":
    "اربط متجرك مع شبكات التسويق الاجتماعي مثل انستاغرام و فيسبوك",
  "Social Marketing": "ادوات التسويق الاجتماعي",
  Social: "ادوات التسويق",
  "New to Hesabe? Request a call from a Hesabe representative.":
    "جديد مع حسابي؟ اطلب مكالمة من احد مندوبي حسابي",
  "Contact me": "طلب مكالمة",
  Contacted: "تم التواصل",
  "You can request another call in 12 hours": "يمكنك اعادة الطلب بعد 12 ساعة",
  "Send message on": "ارسال رسالة عند",
  "Order received": "استلام الطلب",
  "Order prepared": "تحضير الطلب",
  "Order out for delivery": "توصيل الطلب",
  "Order canceled": "الغاء الطلب",
  "Order refunded": "ارجاع نقود الطلب",
  "Order completed": "اتمام الطلب",
  "Online order placed": "وضع طلب اونلاين",
  "Enable debit card payments": "تفعيل الدفع ببطاقة الإئتمان",
  "Enable credit card payments": "تفعيل الدفع ببطاقة الكردت (فيزا، ماستر كارد)",
  "POS order placed": "وضع طلب من نقطة البيع",
  "Enable cash for POS": "تفعيل الكاش عند نقطة البيع",
  "Enable online payment for POS": "تفعيل الدفع الالكتروني عند نقطة البيع",
  "Use MyFatoorah's invoicing page":
    "استخدام صفحة اختيار وسائل الدفع من ماي فاتورة",
  "When disabled, the customer will be able to choose between KNET and credit card options in the checkout page instead of going to MyFatoorah's payment page and choosing the payment method from there":
    "في حال عدم التفعيل، سيتمكن العميل من اختيار وسيلة الدفع في صفحة اتمام الطلب بدلا من ان يتم تحوله الى صفحة ماي فاتورة",
  "Enable low balance notifications": "تفعيل اشعارات الرصيد المنخفض",
  "Once balance goes below": "عندما ينخفض الرصيد اقل من",
  "Email will be sent to": "سوف يتم ارسال الايميل الى",
  "Invalid email": "ايميل غير صحيح",
  "Enable custom payments for POS": "تفعيل خدمات الدفع المخصصه عند نقطة البيع",
  "Standard box size (CM)": "ابعاد صندوق الشحن (سم)",
  "Box maximum weight (KG)": "الوزن الاقصى للصندوق (كجم)",
  "Maximum weight": "الوزن الاقصى",
  Depth: "العمق",
  "You can start selling while Tap reviews your registration details but payouts will not be available until approved. It is recommended to wait until the KYC process is completed and the account is approved by Tap":
    "يمكنك بدء البيع من الآن ولكن لن تتمكن من تحصيل مدفوعاتك حتى يتم التحقق من بياناتك والموافقة من Tap. نقترح الانتظار حتى تصلك الموافقة قبل المباشرة بالبيع",

  "Awaiting approval": "جاري المراجعة",
  Verified: "موثق",
  "Your account is now approved!": "تم توثيق حسابك!",
  "Your account hasn't been approved yet. Check back again later":
    "لم تتم الموافقة حتى الآن. عاود التحقق لاحقا",
  "Show WhatsApp option": "عرض خيار WhatsApp",
  "Block customers from ordering temporarily if the cost of shipping is not provided.":
    "منع العملاء من الطلب مؤقتا اذا لم يتم تقديم تكلفة الشحن",
  "If disabled the default rate for the selected area will be incurred.":
    "اذا تم تعطيل هذا الخيار سيتم احتساب الرسوم الافتراضية للمنطقة المحددة",
  "Cost calculation": "حساب التكلفة",
  "Please put the following URLs in your Sadad's API settings":
    "الرجاء وضع الروابط التالية في اعدادات واجهة برمجة التطبيقات",
  "Payment Success Return URL": "رابط نجاح عملية الدفع",
  "Payment Failed Return URL": "رابط فشل عملية الدفع",
  "Copied successfully": "تم النسخ بنجاح",
  Currencies: "العملات",
  KWD: "دينار كويتي",
  BHD: "دينار بحريني",
  USD: "دولار امريكي",
  GBP: "جنيه استرليني",
  JOD: "دينار اردني",
  SAR: "ريال سعودي",
  QAR: "ريال قطري",
  AED: "درهم اماراتي",
  EUR: "يورو",
  OMR: "ريال عماني",
  "Should customers pay for customs value on arrival?":
    "هل يجب على العملاء دفع قيمة الجمارك عند الوصول؟",

  "Use Your Business Identity on WhatsApp":
    "استخدم هوية نشاطك التجاري على واتساب",
  "Connect your Facebook account to:": "اربط حسابك على فيسبوك بـ:",
  "Send messages using your brand name":
    "ارسل الرسائل باستخدام اسم علامتك التجارية",
  "Use WhatsApp Business templates": "استخدم قوالب واتساب",
  "Automate communication": "اجعل التواصل تلقائي",
  "Continue with Facebook": "المتابعة باستخدام فيسبوك",
  "Send Survery when order is completed": "أرسل استبياناً عند اكتمال الطلب",
  "You dont have to add every row manually. We can generate them for you":
    "لا تحتاج إلى إضافة كل صف يدويًا. يمكننا إنشاء الصفوف لك ",

  "Just fill in these three fields:":
    "ما عليك سوى تعبئة هذه الحقول الثلاثة:",

  "Extra Weight":
    "الوزن الإضافي",

  "how much weight we add each time":
    "كمية الوزن التي نضيفها في كل مرة",

  "Extra Delivery Charge":
    "رسوم التوصيل الإضافية",

  "how much money we add each time":
    "المبلغ الذي نضيفه في كل مرة",

  "Max Weight":
    "الحد الأقصى للوزن",

  "when we should stop":
    "النقطة التي نتوقف عندها",

  "We always start from the":
    "نبدأ دائمًا من",

  "last row in the table":
    "آخر صف في الجدول",

  "Simple example:":
    "مثال بسيط:",

  "The last weight is":
    "آخر وزن هو",

  "5 kg":
    "5 كجم",

  "Extra Weight is":
    "الوزن الإضافي هو",

  "1.5 kg":
    "1.5 كجم",

  "Now we add the weight step by step:":
    "الآن نضيف الوزن خطوة بخطوة:",

  "5 + 1.5 =":
    "5 + 1.5 =",

  "6.5 kg":
    "6.5 كجم",

  "6.5 + 1.5 =":
    "6.5 + 1.5 =",

  "8.0 kg":
    "8.0 كجم",

  "8.0 + 1.5 =":
    "8.0 + 1.5 =",

  "9.5 kg":
    "9.5 كجم",

  "Each time we also add the":
    "في كل مرة نضيف أيضًا",

  "We stop when the next weight would be bigger than":
    "نتوقف عندما يصبح الوزن التالي أكبر من",

  "You can still change or delete any row later if you want":
    "يمكنك تعديل أو حذف أي صف لاحقًا إذا رغبت ",

  "You can't send a message right now because it's been over 24 hours since the customer last contacted you.":
    "لا يمكن إرسال الرسائل حالياً لأنه مرّ أكثر من 24 ساعة منذ آخر رسالة من العميل.",
  Chats: "المحادثات",
  "Setting a Time Offset means your orders are sent ahead of time.":"تعيين إزاحة الوقت يعني أن الطلبات سيتم إرسالها مسبقًا قبل وقت التسليم المحدد.",
  "For example, with a 30-minute offset and an 11:00 delivery time, the order will be sent at 10:30, giving the delivery company extra time to prepare.":"على سبيل المثال، إذا كانت إزاحة الوقت 30 دقيقة ووقت التسليم 11:00، فسيتم إرسال الطلب إلى شركة التوصيل عند 10:30، مما يمنحهم وقتًا إضافيًا للاستعداد.",
  "If no value is provided, the default time offset is 0 minutes, and the order will be sent at the scheduled delivery time.":"في حال عدم إدخال أي قيمة، ستكون إزاحة الوقت الافتراضية 0 دقيقة، وسيتم إرسال الطلب في وقت التسليم المحدد."
};

export default trans;
